import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { bonuses, includes, volumes } from '../data/offer';
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-127" data-mp="18710a20b07v9">
        <div className="mx-auto max-w-5xl" data-id="element-128" data-mp="1d6nf2fvs5w66">
          <header className="text-center" data-id="element-129" data-mp="1d5ca4cqlmidh">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-130" data-mp="yi0vg1z4ei95">
              🏆 PROTOCOLO RESCATE SIBO™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-131" data-mp="139iz4xsj2wxt">
              Tu hoja de ruta en 5 volúmenes y 3 fases para desinflamar, reparar
              y volver a comer normal en 30 días.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-slate-400" data-id="element-132" data-mp="uebdvwgv50xm">
              Contenido educativo e informativo. Complementa el tratamiento
              indicado por tu equipo médico; no lo reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-133" data-mp="3le9ynkwjyxyy">
              📚 5 VOLÚMENES COMPLETOS · 300+ PÁGINAS
            </h3>
          </header>

          <div className="mt-7 space-y-5" data-id="element-134" data-mp="3gich5b9jzlkl">
            {volumes.map(([title, items, border], index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: Math.min(index * 0.05, 0.2),
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex gap-5 rounded-2xl border ${border} bg-brand-ink p-5 sm:p-7`} data-id="element-135" data-mp="3udeswf13055b" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-136" data-mp="36qf0vq3ou3f0" />
                <div data-id="element-137" data-mp="2j02n3ylrhcgi">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-138" data-mp="2izj5kj00wq30">{title}</h4>
                  <ul className="mt-4 space-y-2" data-id="element-139" data-mp="2ezsh4lxyym1n">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-140" data-mp="hywc7wxbcuuh">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-141" data-mp="rofzrfvz1cvo" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-142" data-mp="40evij5tsim2">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-143" data-mp="9016sn23fos8">El Sistema incluye:</h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-144" data-mp="duewc8u2r1oz">
              {includes.map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-145" data-mp="1kf6bfwlsbxeh">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-146" data-mp="1padc0vjrclz6" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-147" data-mp="3034cpjlgck6j">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="2v5cigixc4lz6">
          <header className="text-center" data-id="element-149" data-mp="2v49tigjkotlw">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-150" data-mp="2q5zwe0eafixn" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-151" data-mp="2q3n68zydm29i">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-152" data-mp="2h4ib83m0wr23">SIEMPRE INCLUIDOS</p>
          </header>

          <div className="mt-10 space-y-4" data-id="element-153" data-mp="2c78ncsea8ngd">
            {bonuses.map(([number, title, details, value]) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-154" data-mp="fclzotzuvh7b">
                <span className="w-fit shrink-0 rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-155" data-mp="347bmyw1adrjn">
                  BONO {number}
                </span>
                <div className="flex-1" data-id="element-156" data-mp="2u9fd07k352n4">
                  <h3 className="font-bold" data-id="element-157" data-mp="2u8dzzxjie62r">{title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-158" data-mp="2z6xpg7xb9zzv">
                    {details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-159" data-mp="2kikqd22xg115">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-160" data-mp="2p9t4ucj46cl6" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-161" data-mp="21l9rvjp4dbmr">
                  <span className="text-sm text-slate-500 line-through" data-id="element-162" data-mp="26jl3nzyz5w7m">{value}</span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-163" data-mp="1mx00y13unvmq">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-164" data-mp="1wwh348jw7rdy">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-165" data-mp="1rvl2q4yr2nda">VALOR TOTAL BONOS</p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-166" data-mp="25ut494idy7kn">$56.000</p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-167" data-mp="21thd2ujv5eac">
              GRATIS con tu Protocolo Rescate SIBO™
            </p>
          </div>
        </div>
      </section>
    </>;
}